import Modal from "../../../../components/portal/Modal";
import GrayButton from "../../../../components/UI/buttonUI/GrayButton";

function UpdateSiteSheetError({ errorList, closeAction }) {
  return (
    <Modal onClose={closeAction} modalWidth="flex-center-align sheet-container">
      <div className="w-full px-8 m-auto">
        <h1 className="sheetHeading">There are some errors in your sheet</h1>
        <div className="overflow-y-auto max-h-[500px]">
          {errorList && errorList.length > 0 && (
            <table className="sheet-table">
              <tr className="sheetTableHeadRow">
                <th className="sheetTableTh">Row No.</th>
                <th className="sheetTableTh">Station Id</th>
                <th className="sheetTableTh">Error Description</th>
              </tr>
              {errorList.map((error, index) => {
                return (
                  <tr key={index} className="sheetTableBodyTr">
                    <td className="border border-lg6 p-1.5">
                      {error.row ? error.row : "-"}
                    </td>
                    <td className="border border-lg6 p-1.5">
                      {error.stationId}
                    </td>
                    <td className="border border-lg6 text-left">
                      {error.description.map((desc, ind) => {
                        return (
                          <div className="px-2">
                            <span className="pr-2">{ind + 1}.</span>
                            {desc}
                          </div>
                        );
                      })}
                    </td>
                  </tr>
                );
              })}
            </table>
          )}
        </div>
        <div className="mt-8 flex justify-center ">
          <GrayButton btnText="Close" onClick={closeAction} />
        </div>
      </div>
    </Modal>
  );
}
export default UpdateSiteSheetError;
